import { render, staticRenderFns } from "./_MainHeader.vue?vue&type=template&id=f90f3484&"
import script from "./_MainHeader.vue?vue&type=script&lang=js&"
export * from "./_MainHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports